import { useState } from 'react';

export const useSettingsPage = () => {
    const [activeTab, setActiveTab] = useState(0);
   
    return {
        activeTab,
        setActiveTab
    };
};
